import { render, staticRenderFns } from "./ProposalToggleButton.vue?vue&type=template&id=0a181f30"
import script from "./ProposalToggleButton.vue?vue&type=script&lang=js"
export * from "./ProposalToggleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports